import { MedicalCheckupShortDto } from '../models/medicalCheckups/medicalCheckupShortDto';
import { storageService } from '../services/storageService';

/** Fail-closed: чужой или отсутствующий tenantId не пропускаем в UI. */
export function isCurrentTenantCheckup(checkup: MedicalCheckupShortDto): boolean {
    const userTenantId = storageService.getUserData()?.tenantId;
    if (userTenantId == null || checkup.tenantId == null) {
        return false;
    }
    return checkup.tenantId === userTenantId;
}
